// Task 19: when the vendor-entered legal name differs from the ABN registry's
// entity name, the registry name is the headline and the entered value is shown
// in parentheses beneath it — the registry is authoritative for display, and
// the discrepancy is what the admin needs to notice.
//
// Comparison ignores case and surrounding whitespace so pure formatting
// differences ("Acme Couriers Pty Ltd" vs "ACME COURIERS PTY LTD") don't read
// as a mismatch and flood the page with false flags. A blank-but-present value
// is treated as absent.

const norm = (s: string | null): string => (s ?? '').trim().toLowerCase();
const present = (s: string | null): boolean => (s ?? '').trim() !== '';

export type LegalNameDisplay = {
  /** The name to show as the primary value; null when neither name exists. */
  headline: string | null;
  /** The vendor-entered name, non-null ONLY on a genuine mismatch. */
  entered: string | null;
};

export function legalNameDisplay(
  abnEntityName: string | null,
  enteredName: string | null,
): LegalNameDisplay {
  if (!present(abnEntityName)) return { headline: enteredName, entered: null };
  if (!present(enteredName)) return { headline: abnEntityName, entered: null };
  if (norm(abnEntityName) === norm(enteredName)) {
    // They agree — show what the vendor entered, preserving its formatting.
    return { headline: enteredName, entered: null };
  }
  return { headline: abnEntityName, entered: enteredName };
}
